<template>
    <h3 class="bg-light-blue fix--ticket--item--header py-3 pl-4">
        {{ days }}
        <small>Inicio: {{ startOn }}</small>
    </h3>
</template>

<script>
    moment.locale(window.Valle.lang);

    export default {
        props: {
            startDate: {
                type: String,
                required: true
            }
        },

        computed: {
            days() {
                const days = this.$store.state.daysQuantity;

                return days === 1 ? '1 día' : `${days} días`
            },

            startOn() {
                return moment(this.startDate, 'YYYY-MM-DD').format('LL');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FixTicketHeader.vue